import { render, staticRenderFns } from "./MedtochkaRedirect.vue?vue&type=template&id=11269753&"
import script from "./MedtochkaRedirect.vue?vue&type=script&lang=js&"
export * from "./MedtochkaRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11269753')) {
      api.createRecord('11269753', component.options)
    } else {
      api.reload('11269753', component.options)
    }
    module.hot.accept("./MedtochkaRedirect.vue?vue&type=template&id=11269753&", function () {
      api.rerender('11269753', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/MedtochkaRedirect/MedtochkaRedirect.vue"
export default component.exports